<div
  *ngIf="isVisible$ | async"
  class="smart-banner-container "
  role="banner"
  aria-label="JetBlue mobile app download banner"
>
  <div class="flex items-center justify-between">
    <!-- Close Button -->
    <button
      (click)="dismissBanner()"
      class="smart-banner-close-btn bg-transparent white pointer flex items-center justify-center"
      aria-label="Dismiss app download banner"
    >
    <img
    src="./ui-assets/closeSmall.svg"
    alt="JetBlue App Store Badge"
    height="60"
    width="60"
    alt="JetBlue Home"
  />
    </button>
    <!-- App Icon & Info -->
    <div class="flex items-center flex-1">
      <!-- JetBlue Logo as App Icon -->
      <div class="smart-banner-icon">
        <img
          src="./ui-assets/JB_appstore.svg"
          alt="JetBlue App Store Badge"
          height="60"
          width="60"
          alt="JetBlue Home"
        />
      </div>

      <!-- App Details -->
      <div class="flex-1 min-w-0">
        <div class="title">{{ appName }}</div>
        <div class="description">{{ appDescription }}</div>
        <div class="f7 o-70 rating-container">
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex items-center ml3 flex-shrink-0">
        <!-- Install Button -->
        <button
          (click)="openApp()"
          class="smart-banner-install-btn"
          [attr.aria-label]="
            'Install JetBlue app from ' +
            (deviceType === 'iOS' ? 'App Store' : 'Google Play')
          "
        >
          Open
        </button>
      </div>
    </div>
  </div>
</div>
